"use strict";

import { LoadingBox, Stack } from '@autoguru/overdrive';
import * as styles from './SectionLoading.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionLoading = /*#__PURE__*/_jsxs(Stack, {
  className: styles.loading,
  space: "5",
  width: "full",
  children: [/*#__PURE__*/_jsx(LoadingBox, {
    display: "block"
  }), /*#__PURE__*/_jsx(LoadingBox, {
    display: "block"
  }), /*#__PURE__*/_jsx(LoadingBox, {
    display: "block"
  }), /*#__PURE__*/_jsx(LoadingBox, {
    randomWidth: true,
    display: "block"
  })]
});